import axios from 'axios';

// Swap the underlying HTTP library here without touching any call sites -
// every consumer only ever sees the httpClient.get/post/put/delete interface below.

const API_URL = (process.env.REACT_APP_API_URL || '') + '/api';

const client = axios.create({ baseURL: API_URL });

function authHeaders() {
    const token = localStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
}

async function request(method, url, { data, auth = false, headers = {} } = {}) {
    try {
        const response = await client.request({
            method,
            url,
            data,
            headers: { ...(auth ? authHeaders() : {}), ...headers }
        });
        return response.data;
    } catch (error) {
        const normalized = new Error(error.response?.data?.error || error.message || 'Request failed');
        normalized.status = error.response?.status;
        normalized.data = error.response?.data;
        throw normalized;
    }
}

const httpClient = {
    get: (url, options) => request('get', url, options),
    post: (url, data, options) => request('post', url, { ...options, data }),
    put: (url, data, options) => request('put', url, { ...options, data }),
    delete: (url, options) => request('delete', url, options),
};

export default httpClient;
